import React from 'react';
import {
	formatDateTime,
	getDateSortValue,
} from '@/components/views/SettingsView/BrokerageUsersTable/helpers';
import { UserChip } from './chips/UserChip';

/**
 * A "Date created" column for admin tables whose items have `createdAt` (an ISO string; the
 * admin list endpoints give every item one, from the doc's creation time when it isn't
 * stored). Sorted by date; shown like "Last updated".
 */
export const createdAtColumn = {
	field: 'createdAt',
	headerName: 'Date created',
	width: 190,
	type: 'number',
	headerAlign: 'left',
	align: 'left',
	valueGetter: (value) => getDateSortValue(value),
	valueFormatter: (value, row) => formatDateTime(row.createdAt),
};

/**
 * A "Created by" column for admin tables whose items have `createdBy` (a user doc id): the
 * user as a chip, or empty where it wasn't recorded. Like lastUpdatedByColumn, it can't be
 * sorted (that would sort by id); the export has the id.
 */
export const createdByColumn = {
	field: 'createdBy',
	headerName: 'Created by',
	width: 200,
	sortable: false,
	renderCell: ({ value }) => value && <UserChip id={value} />,
};
